import { useCallback } from "react";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import * as Converter from "../converter";
import * as Schema from "../schema";

import type * as Type from "../type";

type Props = {
	hotelID: string;
	date: string;
};
type QueryData = Type.QueryData.OptionPmsList.OptionPmsActiveListQueryData;
type Result = {
	//
	optionPmsActiveListQueryData: QueryData | undefined;
	//
	onQueryOptionPmsActiveList: (props: Props) => Promise<QueryData | undefined>;
};

export const useOptionPmsActiveListQuery = ({ hotelID, date }: Props): Result => {
	/**
	 * ユーザーアクション起因でのデータ取得のため、refetch を返す
	 */
	const { data, refetch } = useCustomSuspenseQuery(Schema.OPTION_PMS_ACTIVE_LIST_FOR_OPTION_PMS, {
		variables: { hotelID, date },
	});

	const { onConvertOptionPmsActiveList } = Converter.useOptionPmsActiveListConverter();
	/**
	 * refetch をラップし、同期的にデータを取得する
	 */
	const onQueryOptionPmsActiveList = useCallback(
		async ({ hotelID, date }: Props) =>
			refetch({ hotelID, date }).then(({ data }) => {
				if (!data) throw new Error("optionPmsList is undefined");
				/**
				 * QueryData への変換処理
				 */
				return onConvertOptionPmsActiveList({ optionPmsActiveListServerData: data });
			}),
		[onConvertOptionPmsActiveList, refetch],
	);

	const optionPmsActiveListQueryData = onConvertOptionPmsActiveList({ optionPmsActiveListServerData: data });
	return {
		//
		optionPmsActiveListQueryData,
		//
		// refetch
		onQueryOptionPmsActiveList,
	};
};
